export enum Experiment {
  EnablePPCreditAndVenmoTest = 'specs.payments.EnablePPCreditAndVenmoTest',
  EnablePPCreditFor3rdPartyProviders = 'specs.payments.EnablePPCreditFor3rdPartyProviders',
  RestartPayFlowForSpbIfErrorHappens = 'spec.payments-checkout.RestartPayFlowForSpbIfErrorHappens',
  EnableApplePayInChrome = 'specs.payments.EnableApplePayInChrome',
  ShortenApplePayButtonText = 'specs.payments.ShortenApplePayButtonText',
  PassConfirmedInExpressCheckout = 'specs.payments.PassConfirmedInExpressCheckout',
}
